import { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Nav, Table } from 'react-bootstrap';
import { getMyFastrackNodes } from '../../api/fastrackApi';
import { fmtIST } from '../../utils/dateFormat';

const accent = '#cc66ff';
const cardDark = { background: 'linear-gradient(135deg, #0d0d0d 0%, #1a0033 100%)', color: '#fff', border: '1px solid #9933ff44' };

const PlanPanel = ({ planData }) => {
  const { nodes } = planData;
  const completedNodes = nodes.filter((n) => n.status === 'complete');
  if (completedNodes.length === 0) return (
    <div style={{ color: '#555', fontSize: 13, padding: '24px 0' }}>No completed cycles yet.</div>
  );

  return (
    <div>
      <h6 style={{ color: '#aaa', margin: '24px 0 12px' }}>Bonus Transaction Log</h6>
      <Card style={cardDark}>
        <Table responsive className="mb-0" style={{ color: '#ddd' }}>
          <thead style={{ borderBottom: '1px solid #9933ff44' }}>
            <tr>
              <th style={{ color: '#aaa', fontWeight: 500, fontSize: 13 }}>#</th>
              <th style={{ color: '#aaa', fontWeight: 500, fontSize: 13 }}>Completed</th>
              <th style={{ color: '#aaa', fontWeight: 500, fontSize: 13 }}>Batch</th>
              <th style={{ color: '#aaa', fontWeight: 500, fontSize: 13 }}>Bonus (20%)</th>
              <th style={{ color: '#aaa', fontWeight: 500, fontSize: 13 }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {completedNodes.map((node, i) => (
              <tr key={node._id} style={{ borderBottom: '1px solid #9933ff22' }}>
                <td style={{ fontSize: 13 }}>{node.cycleNumber ?? i + 1}</td>
                <td style={{ fontSize: 13 }}>{fmtIST(node.completedAt)}</td>
                <td style={{ fontSize: 13, color: '#aaa' }}>{node.batchNumber ? `Batch ${node.batchNumber}` : '—'}</td>
                <td style={{ fontSize: 13, color: '#66ff99', fontWeight: 600 }}>{node.bonusAmount} USDT</td>
                <td style={{ fontSize: 13 }}>
                  {node.bonusStatus === 'credited' && <span style={{ color: '#66ff99', fontWeight: 600 }}>✓ Credited</span>}
                  {node.bonusStatus === 'held' && <span style={{ color: '#ffaa44', fontWeight: 600 }}>⏸ On Hold</span>}
                  {node.bonusStatus === 'pending' && <span style={{ color: '#555' }}>—</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </div>
  );
};

const Fastrack = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activePlanKey, setActivePlanKey] = useState(null);

  useEffect(() => {
    getMyFastrackNodes()
      .then((res) => {
        setData(res.data);
        if (res.data.plans?.length > 0) setActivePlanKey(res.data.plans[0].plan._id);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" style={{ color: accent }} />
      </Container>
    );
  }

  const hasPlans = data?.plans?.length > 0;

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 40 }}>
      <Container className="pt-4">
        <div className="mb-4">
          <h4 style={{ color: '#fff', fontWeight: 700 }}>Global Fastrack Bonus</h4>
          <div style={{ color: '#aaa', fontSize: 13 }}>
            Global fastrack income — earn 20% when your Cycle completes, then rebirth and repeat
          </div>
        </div>

        {/* Total Credited */}
        {data?.summary && (
          <Row className="g-3 mb-4">
            <Col xs={6} md={3}>
              <Card style={{ ...cardDark, borderColor: '#66ff9944' }} className="text-center p-3">
                <div style={{ fontSize: 24, fontWeight: 800, color: '#66ff99' }}>
                  {data.summary.totalBonusEarned.toFixed(2)}
                </div>
                <div style={{ color: '#aaa', fontSize: 12 }}>Total Credited (USDT)</div>
              </Card>
            </Col>
          </Row>
        )}

        {!hasPlans ? (
          <Card style={cardDark} className="text-center p-5">
            <div style={{ color: '#555', fontSize: 14 }}>
              You have not subscribed to any plan yet.<br />
              Subscribe to a plan to enter the Global Fastrack network.
            </div>
          </Card>
        ) : (
          <>
            {data.plans.length > 1 && (
              <Nav variant="tabs" className="mb-4" style={{ borderBottom: '1px solid #9933ff44', overflowX: 'auto', overflowY: 'hidden', flexWrap: 'nowrap', WebkitOverflowScrolling: 'touch' }}>
                {data.plans.map(({ plan }) => (
                  <Nav.Item key={plan._id}>
                    <Nav.Link
                      active={activePlanKey === plan._id}
                      onClick={() => setActivePlanKey(plan._id)}
                      style={{
                        color: activePlanKey === plan._id ? accent : '#aaa',
                        background: activePlanKey === plan._id ? '#1a003388' : 'transparent',
                        border: activePlanKey === plan._id ? `1px solid ${accent}` : '1px solid transparent',
                        borderBottom: 'none',
                        cursor: 'pointer',
                      }}
                    >
                      {plan.planName} — {plan.amount} USDT
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            )}

            {data.plans
              .filter((pd) => data.plans.length === 1 || activePlanKey === pd.plan._id)
              .map((pd) => (
                <PlanPanel key={pd.plan._id} planData={pd} />
              ))}
          </>
        )}
      </Container>
    </div>
  );
};

export default Fastrack;
